import React, { Dispatch, SetStateAction } from 'react';

import { StateLanguage } from '../../languages/config/StateLanguage';
import { evaluateLegendMapObjectRequired } from '../../scripts/validate.legend.script';
import { expressions } from '../../libraries/regular.expressions.library';
import { suffixLegend } from '../../scripts/name.legend.script';
import { removeTooltip } from '../../utils/tooltip.util';
import { calculateRebate } from '../../scripts/financial.calculation.script';

import AppLegend from './Legend';

export interface AppRequirementInputPriceProps {
  content: {value: any, index: number, sub_index: number},
  requirements: {list: boolean, value: {type: string, description: string, contents: any[]}[], valid: {type: boolean, description: boolean, content: boolean, contents: any[]}[]},
  setRequirements: Dispatch<SetStateAction<{list: boolean, value: {type: string, description: string, contents: any[]}[], valid: {type: boolean, description: boolean, content: boolean, contents: any[]}[]}>>,
  validateRebaja?: Function
};

const AppRequirementInputPrice: React.FunctionComponent<AppRequirementInputPriceProps> = ({content, requirements, setRequirements, validateRebaja}) => {
  const {lang} = StateLanguage()

  const handleChangePriceContentToRequirement = (event: React.ChangeEvent <HTMLFormElement | HTMLInputElement>) => {
    let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].price_unit = event.target.value
        if (validateRebaja) {
          temp_item.contents[content.sub_index].rebate_amount = calculateRebate(temp_item.contents[content.sub_index].reference, temp_item.contents[content.sub_index].quantity, event.target.value, temp_item.contents[content.sub_index].tax_included, temp_item.contents[content.sub_index].tax_rate, temp_item.contents[content.sub_index].rebate_type, temp_item.contents[content.sub_index].rebate_value, temp_item.contents[content.sub_index].rebate_quantity, temp_item.contents[content.sub_index].rebate_amount)
        }
      }
      return temp_item
    })

    setRequirements({...requirements, value: tempRequirementsValue})
  }

  const handleChangeTaxIncludeContentToRequirement = () => {
    let tempRequirementsValue = requirements.value.map((temp_item, temp_index) => {
      if (content.index === temp_index) {
        temp_item.contents[content.sub_index].tax_included = !content.value.tax_included
        if (validateRebaja) {
          temp_item.contents[content.sub_index].rebate_amount = calculateRebate(temp_item.contents[content.sub_index].reference, temp_item.contents[content.sub_index].quantity, temp_item.contents[content.sub_index].price_unit, content.value.tax_included, temp_item.contents[content.sub_index].tax_rate, temp_item.contents[content.sub_index].rebate_type, temp_item.contents[content.sub_index].rebate_value, temp_item.contents[content.sub_index].rebate_quantity, temp_item.contents[content.sub_index].rebate_amount)
        }
      }
      return temp_item
    })

    if (validateRebaja) {
      validateRebaja(content.index, content.sub_index)
    }

    setRequirements({...requirements, value: tempRequirementsValue})
    removeTooltip()
  }

  const validatePriceContentToRequirement = () => {
    evaluateLegendMapObjectRequired(expressions.currency, content.index, content.sub_index, 'price_unit', requirements, setRequirements, `legend-requirement-content-price-valid${suffixLegend(content.index, content.sub_index)}`, `legend-requirement-content-price-required${suffixLegend(content.index, content.sub_index)}`)

    if (validateRebaja) {
      validateRebaja(content.index, content.sub_index)
    }
  }

  return (
    <>
      <div className="position-relative">
        <input className="form-control ps-2 pe-20" type="text" autoComplete="off" name="price" value={content.value.price_unit} onChange={handleChangePriceContentToRequirement} onKeyUp={validatePriceContentToRequirement} onBlur={validatePriceContentToRequirement} />
        <button className="btn btn-bg-info btn-flex flex-center position-absolute translate-middle-y top-50 end-0 h-25px w-55px me-2" type="button" onClick={handleChangeTaxIncludeContentToRequirement}>
          <span className="btn-label text-secondary text-uppercase fw-bolder fs-8" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" data-bs-original-title={content.value.tax_included ? lang.labels.thisOptionIncludeTaxPrice : lang.labels.thisOptionNotIncludeTaxPrice}>
            {content.value.tax_included ? lang.labels.net : lang.labels.gross}
          </span>
        </button>
      </div>
      <AppLegend attribute={{check: requirements.valid[content.index].contents[content.sub_index].price_unit, name: "requirement-content-price", index: content.index, sub_index: content.sub_index}} container={{valid: true, required: true, identical: false, exists: false}}></AppLegend>
    </>
  )
}

export default AppRequirementInputPrice;
